(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { host.MNLViceLayout = api; api.bootCards(host.document); }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var WIDTH = 1818, HEIGHT = 1142, FRONT_CENTER = 340;
  var PANELS = { identity: [0, 390], artwork: [390, 552], composition: [942, 550], information: [1492, 326] };
  var COLORS = { background: '#1a1327', ink: '#fff5ee', aqua: '#85eff2', pink: '#ff98c9', muted: '#e8d5e6', line: '#614064' };
  var SANS = 'system-ui, -apple-system, "Segoe UI", Arial, sans-serif';
  var MANROPE = '"MNL Vice Manrope", Manrope, Arial, sans-serif';
  var PRICEDOWN = '"MNL Vice Pricedown", Pricedown, Impact, sans-serif';
  var MONOGRAM = 'M0 0L0 364L48 334L48 100L141 178L233 100L233 257L280 214L280 0L141 116ZM66 146L66 512L107 512L107 263L217 392L217 146L174 183L174 257L105 183ZM130 329L130 512L281 512L249 451L180 451L180 384Z';
  var fontLoads = typeof WeakMap === 'function' ? new WeakMap() : null;
  var PRINT_INGREDIENTS = {
    "cafeine anhydre": [
      0,
      "mg"
    ],
    "l theanine": [
      0,
      "mg"
    ],
    "l tyrosine": [
      0,
      "mg"
    ],
    "l citrulline": [
      1,
      "g"
    ],
    "glycerol": [
      1,
      "g"
    ],
    "sel rose himalaya": [
      1,
      "mg"
    ],
    "beta alanine": [
      2,
      "g"
    ],
    "betaine anhydre": [
      2,
      "mg"
    ],
    "taurine": [
      2,
      "mg"
    ],
    "creatine monohydrate": [
      2,
      "g"
    ],
    "electrolytes k mg na": [
      3,
      "mg"
    ],
    "piperine": [
      3,
      "mg"
    ],
    "cafeine": [
      0,
      "mg"
    ],
    "sel rose": [
      1,
      "mg"
    ],
    "sel rose de l himalaya": [
      1,
      "mg"
    ],
    "sel de l himalaya": [
      1,
      "mg"
    ],
    "creatine": [
      2,
      "g"
    ],
    "electrolytes": [
      3,
      "mg"
    ],
    "complexe electrolytique": [
      3,
      "mg"
    ],
    "betaine": [
      2,
      "mg"
    ]
  };

  function text(value, fallback, max) {
    var result = String(value == null ? '' : value).normalize('NFC').replace(/[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/g, '').replace(/\s+/g, ' ').trim();
    return (result || fallback || '').slice(0, max || 140);
  }
  function formulaLines(value) {
    var words = text(value, 'TA FORMULE', 80).toLocaleUpperCase('fr-FR').split(' ');
    return words.length < 2 ? ['', words[0]] : [words[0], words.slice(1).join(' ')];
  }
  function measuredSize(measure, value, width, size, min, family, weight) {
    while (size > min && measure(value, size, family, weight) > width) size--;
    return size;
  }
  function frontLayout(label, measure) {
    label = label || {};
    measure = measure || function (value, size) { return String(value).length * size * .57; };
    var lines = formulaLines(label.name), size = 58;
    lines.forEach(function (line) { if (line) size = Math.min(size, measuredSize(measure, line, 338, 58, 8, MANROPE, '800')); });
    var nameTop = 305, nameHeight = lines[0] ? size * 2 * 1.03 : size * 1.03;
    var whoTop = nameTop + nameHeight + 26;
    var sloganTop = whoTop + 68;
    return {
      lines: lines, nameSize: size, nameTop: nameTop, nameHeight: nameHeight,
      whoTop: whoTop, sloganTop: sloganTop, noCaffeineTop: sloganTop + 101,
      editionTop: sloganTop + (label.noCaffeine ? 168 : 111),
      flavorTop: 901, netTop: 1015,
      anchors: { name: [195, nameTop + nameHeight / 2], flavor: [185, 956], format: [72, 1070], edition: [195, sloganTop + (label.noCaffeine ? 194 : 137)], composition: [1217, 218] }
    };
  }
  function cover(sourceWidth, sourceHeight) {
    var scale = Math.max(WIDTH / sourceWidth, HEIGHT / sourceHeight);
    var width = Math.min(sourceWidth, WIDTH / scale), height = Math.min(sourceHeight, HEIGHT / scale);
    return { x: (sourceWidth - width) / 2, y: (sourceHeight - height) / 2, width: width, height: height };
  }
  function texturePoint(point) {
    return [(((point[0] + WIDTH / 2 - FRONT_CENTER) % WIDTH + WIDTH) % WIDTH) / WIDTH * 2048, point[1] / HEIGHT * 1024];
  }
  function anchors(label) {
    var result = {}, source = frontLayout(label).anchors;
    Object.keys(source).forEach(function (key) { result[key] = texturePoint(source[key]); });
    return result;
  }
  function focusPreset(value, label) {
    var key = ['whole', 'recap-composition', 'composition', 'format', 'flavor', 'name'].indexOf(value) !== -1 ? value : 'whole';
    var point = frontLayout(label).anchors[key === 'recap-composition' ? 'composition' : key];
    var angle = point ? -(point[0] - FRONT_CENTER) / WIDTH * 360 : 0;
    angle = ((angle + 180) % 360 + 360) % 360 - 180;
    var presets = {
      whole: { zoom: 1, y: 0 }, 'recap-composition': { zoom: 1, y: 0 },
      composition: { zoom: 1.7, y: .47 }, format: { zoom: 3.05, y: -1.19 },
      flavor: { zoom: 2.05, y: -.93 }, name: { zoom: 1.95, y: .25 }
    };
    return { focus: key, angle: angle, zoom: presets[key].zoom, x: 0, y: presets[key].y };
  }
  function put(ctx, value, x, y, width, size, weight, family, color, align) {
    value = text(value, '', 180);
    ctx.textAlign = align || 'left'; ctx.textBaseline = 'top'; ctx.fillStyle = color || COLORS.ink;
    size = measuredSize(function (v, s, f, w) { ctx.font = w + ' ' + s + 'px ' + f; return ctx.measureText(v).width; }, value, width, size, 12, family || SANS, weight || '500');
    ctx.font = (weight || '500') + ' ' + size + 'px ' + (family || SANS);
    ctx.fillText(value, x, y, width);
    return size;
  }
  function line(ctx, x, y, width, color, height) { ctx.fillStyle = color || COLORS.line; ctx.fillRect(x, y, width, height || 1); }
  function measureContext(ctx) {
    return function (value, size, family, weight) { ctx.font = weight + ' ' + size + 'px ' + family; return ctx.measureText(value).width; };
  }
  function compositionRows(rows) {
    if (!Array.isArray(rows)) return [];
    return rows.map(function (row, index) {
      var name = String(row.name || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
      var reference = PRINT_INGREDIENTS[name], pillar = reference ? reference[0] : 3;
      var amount = String(row.dose || '').replace(',', '.').replace(/(\d)[\s\u00a0\u202f](?=\d{3}\b)/g, '$1').match(/([\d.]+)\s*(mg|g)?/i);
      var unit = amount && amount[2] || (reference ? reference[1] : 'mg');
      var grams = amount ? Number(amount[1]) / (unit.toLowerCase() === 'g' ? 1 : 1000) : 0;
      return { row: row, index: index, pillar: pillar, grams: Number.isFinite(grams) ? grams : 0 };
    }).sort(function (a, b) { return a.pillar - b.pillar || b.grams - a.grams || a.index - b.index; }).map(function (entry) { return entry.row; });
  }
  function canonical(ctx, label, flavorImage, artwork) {
    label = label || {};
    var layout = frontLayout(label, measureContext(ctx));
    ctx.fillStyle = COLORS.background; ctx.fillRect(0, 0, WIDTH, HEIGHT);
    var aw = artwork && Number(artwork.naturalWidth || artwork.width), ah = artwork && Number(artwork.naturalHeight || artwork.height);
    if (Number.isFinite(aw) && Number.isFinite(ah) && aw > 0 && ah > 0) {
      var crop = cover(aw, ah); ctx.drawImage(artwork, crop.x, crop.y, crop.width, crop.height, 0, 0, WIDTH, HEIGHT);
    }
    var shade = ctx.createLinearGradient(0, 0, 390, 0);
    shade.addColorStop(0, 'rgba(16,10,24,.92)'); shade.addColorStop(.72, 'rgba(16,10,24,.68)'); shade.addColorStop(1, 'rgba(16,10,24,.12)');
    ctx.fillStyle = shade; ctx.fillRect(0, 0, 390, HEIGHT);
    var sceneShade = ctx.createLinearGradient(390, 0, 942, 0);
    sceneShade.addColorStop(0, 'rgba(16,10,24,.12)'); sceneShade.addColorStop(.28, 'rgba(16,10,24,0)'); sceneShade.addColorStop(.7, 'rgba(16,10,24,0)'); sceneShade.addColorStop(1, 'rgba(16,10,24,.32)');
    ctx.fillStyle = sceneShade; ctx.fillRect(390, 0, 552, HEIGHT);
    ctx.fillStyle = COLORS.background; ctx.fillRect(942, 0, 876, HEIGHT);
    line(ctx, 0, 0, WIDTH, COLORS.aqua, 4); line(ctx, 0, HEIGHT - 4, WIDTH, COLORS.aqua, 4);
    if (typeof Path2D === 'function') {
      ctx.save(); ctx.translate(26, 28); ctx.scale(166 / 512, 166 / 512); ctx.fillStyle = COLORS.ink; ctx.fill(new Path2D(MONOGRAM)); ctx.restore();
    } else put(ctx, 'MNL', 26, 28, 91, 40, '800', MANROPE);
    ['MY', 'NUTRI', 'LAB'].forEach(function (word, index) { put(ctx, word, 135, 28 + index * 62.31, 225, 67, '400', PRICEDOWN, index === 2 ? COLORS.pink : COLORS.ink); });
    put(ctx, label.product || 'PRÉ-WORKOUT PERSONNALISÉ', 26, 276, 338, 14, '700', SANS, COLORS.aqua);
    var first = layout.lines[0], second = layout.lines[1];
    if (first) put(ctx, first, 26, layout.nameTop, 338, layout.nameSize, '800', MANROPE, COLORS.ink);
    put(ctx, second, 26, layout.nameTop + (first ? layout.nameSize * 1.03 : 0), 338, layout.nameSize, '800', MANROPE, COLORS.aqua);
    put(ctx, 'CONÇU POUR', 26, layout.whoTop, 338, 13, '500', SANS, COLORS.muted);
    put(ctx, label.who || 'TOI', 26, layout.whoTop + 23, 338, 22, '750', SANS, COLORS.ink);
    ['Votre formule.', 'Votre énergie.', 'Vos règles.'].forEach(function (value, index) { put(ctx, value, 26, layout.sloganTop + index * 28.6, 338, 22, '700', SANS, index === 2 ? COLORS.pink : COLORS.ink); });
    if (label.noCaffeine) { line(ctx, 26, layout.noCaffeineTop, 338, COLORS.aqua); put(ctx, 'SANS CAFÉINE', 38, layout.noCaffeineTop + 10, 314, 14, '700', SANS, COLORS.aqua); line(ctx, 26, layout.noCaffeineTop + 40, 338, COLORS.aqua); }
    line(ctx, 26, layout.editionTop, 338, COLORS.aqua); put(ctx, 'VICE EDITION', 26, layout.editionTop + 14, 338, 16, '800', SANS, COLORS.aqua); line(ctx, 26, layout.editionTop + 49, 338, COLORS.aqua);
    ctx.save(); ctx.beginPath(); ctx.arc(71, layout.flavorTop + 67, 45, 0, Math.PI * 2); ctx.clip();
    var fw = flavorImage && Number(flavorImage.naturalWidth || flavorImage.width), fh = flavorImage && Number(flavorImage.naturalHeight || flavorImage.height);
    if (Number.isFinite(fw) && Number.isFinite(fh) && fw > 0 && fh > 0) { var fs = Math.min(fw, fh); ctx.drawImage(flavorImage, (fw - fs) / 2, (fh - fs) / 2, fs, fs, 26, layout.flavorTop + 22, 90, 90); }
    else { ctx.fillStyle = '#271d36'; ctx.fillRect(26, layout.flavorTop + 22, 90, 90); }
    ctx.restore();
    put(ctx, 'SAVEUR', 130, layout.flavorTop + 45, 234, 13, '800', SANS, COLORS.muted);
    put(ctx, label.flavor || 'Neutre', 130, layout.flavorTop + 64, 234, 27, '800', MANROPE, COLORS.ink);
    line(ctx, 26, layout.netTop, 338, COLORS.aqua);
    put(ctx, (String(label.format || label.portions || '30').match(/\d+/) || ['30'])[0], 26, layout.netTop + 16, 88, 43, '750', SANS, COLORS.ink);
    put(ctx, 'PORTIONS', 26, layout.netTop + 64, 90, 12, '500', SANS, COLORS.muted);
    if (label.serving) { put(ctx, '1 DOSE', 123, layout.netTop + 34, 96, 12, '500', SANS, COLORS.muted); put(ctx, label.serving, 123, layout.netTop + 54, 96, 26, '700', SANS); }
    if (label.netWeight) { put(ctx, 'POIDS NET', 240, layout.netTop + 34, 124, 12, '500', SANS, COLORS.muted); put(ctx, label.netWeight, 240, layout.netTop + 54, 124, 26, '700', SANS); }
    line(ctx, 942, 0, 1, COLORS.line, HEIGHT); line(ctx, 964, 24, 506, COLORS.aqua, 5);
    put(ctx, 'Votre formule, en détail.', 964, 45, 506, 27, '750', SANS);
    put(ctx, label.compositionTitle || 'Composition par portion', 964, 89, 506, 16, '500', SANS, COLORS.muted);
    put(ctx, 'FORMULE : ' + text(label.name, 'TA FORMULE', 80).toLocaleUpperCase('fr-FR'), 964, 129, 506, 13, '700', SANS);
    line(ctx, 964, 158, 506, COLORS.line, 2);
    var rows = compositionRows(label.composition);
    rows.slice(0, 16).forEach(function (row, index) {
      var x = 964 + index % 2 * 261, y = 180 + Math.floor(index / 2) * 44;
      ctx.fillStyle = COLORS.aqua; ctx.beginPath(); ctx.arc(x + 2, y + 13, 2, 0, Math.PI * 2); ctx.fill();
      put(ctx, row.name, x + 10, y + 2, 147, 16, '500', SANS);
      put(ctx, row.dose, x + 245, y + 2, 80, 16, '750', SANS, COLORS.ink, 'right');
      line(ctx, x, y + 35, 245, COLORS.line);
    });
    line(ctx, 1510, 24, 290, COLORS.line);
    put(ctx, 'MYNUTRILAB', 1510, 46, 290, 21, '800', MANROPE, COLORS.aqua);
    put(ctx, 'VICE EDITION', 1510, 87, 290, 16, '800', SANS, COLORS.aqua);
  }
  function paintTexture(canvas, label, flavorImage, artwork) {
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    ctx.save(); ctx.scale(canvas.width / WIDTH, canvas.height / HEIGHT);
    var shift = WIDTH / 2 - FRONT_CENTER;
    [shift, shift - WIDTH].forEach(function (x) { ctx.save(); ctx.translate(x, 0); canonical(ctx, label, flavorImage, artwork); ctx.restore(); });
    ctx.restore();
  }
  function paintFront(canvas, label, flavorImage, artwork) {
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    ctx.save(); ctx.scale(canvas.width / 942, canvas.height / HEIGHT); canonical(ctx, label, flavorImage, artwork); ctx.restore();
  }
  function safeAsset(value, doc) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try { var url = new URL(value, doc.location.href); return url.protocol === 'https:' || url.protocol === 'http:' && /^(localhost|127\.0\.0\.1)$/.test(url.hostname) ? url.href : ''; } catch (_) { return ''; }
  }
  function loadFonts(doc, fonts) {
    if (!doc || !doc.fonts || !doc.defaultView || typeof doc.defaultView.FontFace !== 'function') return Promise.resolve(false);
    if (fontLoads && fontLoads.has(doc)) return fontLoads.get(doc);
    fonts = fonts || {};
    var configs = [['MNL Vice Pricedown', fonts.pricedown, '400'], ['MNL Vice Manrope', fonts.manrope700, '700'], ['MNL Vice Manrope', fonts.manrope800, '800']];
    var loading = Promise.all(configs.map(function (entry) {
      var url = safeAsset(entry[1] || '', doc); if (!url) return Promise.resolve(false);
      var face = new doc.defaultView.FontFace(entry[0], 'url("' + url + '")', { weight: entry[2], style: 'normal' });
      doc.fonts.add(face); return face.load().then(function () { return true; }, function () { return false; });
    })).then(function (values) { return values.every(Boolean); });
    if (fontLoads) fontLoads.set(doc, loading);
    return loading;
  }
  function applyPrint(root) {
    if (!root) return;
    if (!root.classList.contains('gta')) { root.removeAttribute('data-mnl-vice-layout'); return; }
    var doc = root.ownerDocument, fname = root.querySelector('.fname');
    var ctx = doc.createElement('canvas').getContext('2d');
    var lines = fname ? Array.prototype.slice.call(fname.children).map(function (span) { return span.textContent; }) : [];
    var label = { name: lines.length ? lines.join(' ') : fname ? fname.textContent : '', noCaffeine: !!root.querySelector('.nocaf') };
    var layout = frontLayout(label, ctx ? measureContext(ctx) : null);
    root.setAttribute('data-mnl-vice-layout', '4');
    var vars = { 'name-size': layout.nameSize + 'px', 'name-top': layout.nameTop + 'px', 'who-top': layout.whoTop + 'px', 'slogan-top': layout.sloganTop + 'px', 'no-caffeine-top': layout.noCaffeineTop + 'px', 'edition-top': layout.editionTop + 'px', 'flavor-top': layout.flavorTop + 'px', 'net-top': layout.netTop + 'px' };
    Object.keys(vars).forEach(function (key) { root.style.setProperty('--vice-' + key, vars[key]); });
  }
  function bootCards(doc) {
    if (!doc) return;
    function start() {
      var cards = Array.prototype.slice.call(doc.querySelectorAll('canvas[data-mnl-vice-card]'));
      if (!cards.length) return;
      var boot = doc.defaultView.MNL_CFG_BOOT || {};
      function renderCard(canvas) {
        var fontPromise = loadFonts(doc, boot.viceFonts);
        var image = doc.createElement('img'), ready = false, label = { name: canvas.getAttribute('data-default-name'), flavor: 'Ice Tea', format: '30' };
        function draw() { paintFront(canvas, label, null, ready ? image : null); }
        draw(); image.crossOrigin = 'anonymous'; image.referrerPolicy = 'no-referrer';
        image.onload = function () { ready = !!image.naturalWidth; draw(); }; image.onerror = function () {};
        var url = safeAsset(canvas.getAttribute('data-artwork') || '', doc); if (url) image.src = url;
        fontPromise.then(draw);
      }
      if (doc.defaultView.IntersectionObserver) {
        var observer = new doc.defaultView.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) { observer.unobserve(entry.target); renderCard(entry.target); } });
        }, { rootMargin: '80px' });
        cards.forEach(function (canvas) { observer.observe(canvas); });
      } else cards.forEach(renderCard);
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  }
  return { width: WIDTH, height: HEIGHT, frontCenter: FRONT_CENTER, panels: PANELS, colors: COLORS, formulaLines: formulaLines, frontLayout: frontLayout, cover: cover, texturePoint: texturePoint, anchors: anchors, focusPreset: focusPreset, compositionRows: compositionRows, paintTexture: paintTexture, paintFront: paintFront, loadFonts: loadFonts, applyPrint: applyPrint, bootCards: bootCards };
});
